export const CREDIT_MEMOS_GATE = 'commerce:invoices:creditMemos';
export const STRIPE_CONFIRMATION_TOKEN_GATE = 'Checkout:StripeConfirmationToken';